export default __webpack_public_path__ + "static/media/breakfast.d891fa01.svg";